import { assert } from '../../../lib/assert-sidecar'
import { rando } from '../../../lib/rando-sidecar'
import { common } from '../../../main/common-sidecar'
import { voyageCarryable } from '../voyageCarryable-sidecar'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageCrew_alien } from '../voyageCrew_alien-sidecar'
import { voyageGameStatus } from '../voyageGameStatus-sidecar'
import { voyageTestParams } from '../voyageTestParams-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageWaveType } from './voyageMissionDataWaves'
import { voyageMissionEvent_boarded } from './voyageMissionEvent_boarded-sidecar'
import { voyageMissionEvent_bomb } from './voyageMissionEvent_bomb-sidecar'
import { voyageMissionEvent_breach } from './voyageMissionEvent_breach-sidecar'
import { voyageMissionEvent_enemyShip } from './voyageMissionEvent_enemyShip-sidecar'
import { voyageMissionEvent_fire } from './voyageMissionEvent_fire-sidecar'

export function* generator_mission_waves(): Generator<number, number, number> {
  while (true) {
    // TODO: always make sure we are host for this stuff?
    if (!voyageWebsockets.getIsHost()) {
      yield 0
      continue
    }

    let mission = voyageGameStatus.get().currentMission

    if (mission.waveIdx >= mission.waves.length) {
      break
    }

    let wave = mission.waves[mission.waveIdx]

    let ds = common.getUpdateDeltaScaled()

    if (wave.waitTillClear) {
      let numAliens = voyageCrew_alien.countAliens()
      let numBombs = voyageCarryable.countBombs()
      let hasAlienShip = voyageGameStatus.get().enemyShip.active
      console.log('wave info', numAliens, numBombs, hasAlienShip)
      if (numAliens > 0) {
        yield 0
        continue
      }
      if (numBombs > 0) {
        yield 0
        continue
      }
      if (hasAlienShip) {
        yield 0
        continue
      }
    }
    mission.waveTimer -= ds

    if (mission.waveTimer <= 0) {
      mission.waveTimer = wave.postWaveTime
      mission.waveIdx++

      console.log('WAVE', wave.type)
      if (wave.type === EVoyageWaveType.Fire) {
        voyageMissionEvent_fire.run_fire()
      } else if (wave.type === EVoyageWaveType.HullBreach) {
        voyageMissionEvent_breach.run_breach()
      } else if (wave.type === EVoyageWaveType.AlienShip) {
        voyageMissionEvent_enemyShip.run_enemyShip()
      } else if (wave.type === EVoyageWaveType.BoardedByAliens) {
        voyageMissionEvent_boarded.run_boarded(wave.amount, wave.amount)
      } else if (wave.type === EVoyageWaveType.Bomb) {
        voyageMissionEvent_bomb.run_bomb(wave.amount, wave.amount)
      } else if (wave.type === EVoyageWaveType.Null) {
      } else {
        assert.failed('unhandled wave type', wave.type)
      }
    }
    yield 0
  }
  return 0
}
